/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 6: Foundation Peak (Days 151-180)
 *
 * Squeeze at 60-70%, hold 8-10s. Standing squeezes. The Knack.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  bridge_activation: {
    id: 'bridge_activation',
    name: 'Bridge Activation',
    name_pt: 'Ponte com Ativação',
    sub: 'Squeeze first, then lift hips. Always this order.',
    sub_pt: 'Aperte primeiro, depois levante quadril. Sempre essa ordem.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie on your back, knees bent, feet flat.

Squeeze pelvic floor first. THEN lift hips into a bridge. Hold bridge AND squeeze for 5 seconds.

Lower hips slowly. Release squeeze as hips touch ground.

The sequence: floor first, then hips. Always.

Picture it: a drawbridge raising. Chains pull first (pelvic floor), THEN bridge lifts (hips). Chains always lead.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Aperte assoalho primeiro. DEPOIS levante quadril em ponte. Segure ponte E aperto por 5 segundos.

Abaixe quadril devagar. Solte aperto quando quadril tocar chão.

A sequência: assoalho primeiro, depois quadril. Sempre.

Visualize: ponte levadiça subindo. Correntes puxam primeiro (assoalho), DEPOIS ponte sobe (quadril). Correntes sempre lideram.`,
    breathe: 'Exhale to squeeze and lift. Inhale to lower and release.',
    breathe_pt: 'Expire para apertar e levantar. Inspire para abaixar e soltar.',
    timerCue: `Squeeze.
Lift.
Hold.
Lower.`,
    timerCue_pt: `Aperte.
Levante.
Segure.
Abaixe.`,
    feel: 'Floor and glutes working together. The floor starts first.',
    feel_pt: 'Assoalho e glúteos trabalhando juntos. O assoalho começa primeiro.',
    avoid: 'Do not lift before squeezing. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não levante antes de apertar. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 10,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  fast_squeeze: {
    id: 'fast_squeeze',
    name: 'Fast Squeeze',
    name_pt: 'Aperto Rápido',
    sub: 'Maximum effort. 1 second. Full release.',
    sub_pt: 'Esforço máximo. 1 segundo. Soltura total.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. Squeeze at maximum effort for 1 second. Release completely for 2 seconds.

This targets fast-twitch fibers that handle pressure spikes: coughing, laughing, sneezing, jumping.

Picture it: flicking a light switch. On for 1 second. Off completely. No dimming.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Aperte com esforço máximo por 1 segundo. Solte completamente por 2 segundos.

Isso trabalha fibras rápidas que lidam com picos de pressão: tosse, risada, espirro, salto.

Visualize: interruptor de luz. Liga 1 segundo. Desliga completamente. Sem dimmer.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze!
Release.`,
    timerCue_pt: `Aperte!
Solte.`,
    feel: 'Sharp, fast contraction. Full instant release.',
    feel_pt: 'Contração aguda e rápida. Soltura instantânea total.',
    avoid: 'Do not let tension linger. Do not bear down.',
    avoid_pt: 'Não deixe tensão persistir. Não faça força.',
    type: 'pulse',
    sets: 4,
    rest: 10,
    reps: 12,
    on: 1,
    off: 2,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  pulsacao: {
    id: 'pulsacao',
    name: 'Pulsação',
    name_pt: 'Pulsação',
    sub: '1 second on, 1 second off. Clean rhythm. Each rep starts fresh.',
    sub_pt: '1 segundo liga, 1 segundo desliga. Ritmo limpo. Cada repetição começa limpa.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit with feet flat. CLOSE and SQUEEZE for 1 second. Release completely for 1 second. That is one rep.

Each contraction is independent. Do not let tension accumulate across reps. The release is 50% of the exercise.

After each set, do 3 Gentle Pushes to confirm full rest.

Picture it: a camera shutter. Click open, click closed. Sharp and complete. No blur between open and closed.`,
    inst_pt: `Sente com pés apoiados. FECHE e APERTE por 1 segundo. Solte completamente por 1 segundo. Isso é uma repetição.

Cada contração é independente. Não deixe tensão acumular. A soltura é 50% do exercício.

Após cada série, faça 3 Empurrões Suaves para confirmar repouso.

Visualize: obturador de câmera. Clique abre, clique fecha. Nítido e completo. Sem borrão.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Release.`,
    timerCue_pt: `Aperte.
Solte.`,
    feel: 'Clean on-off rhythm. Release as complete as contraction.',
    feel_pt: 'Ritmo liga-desliga limpo. Soltura tão completa quanto contração.',
    avoid: 'Do not let tension build across reps. Do not bear down.',
    avoid_pt: 'Não deixe tensão acumular entre repetições. Não faça força.',
    type: 'pulse',
    sets: 5,
    rest: 10,
    reps: 12,
    on: 1,
    off: 1,
  },

  squeeze_10s: {
    id: 'squeeze_10s',
    name: 'Peak Hold 10s',
    name_pt: 'Sustentação Pico 10s',
    sub: '70% effort. 10 seconds.',
    sub_pt: '70% de esforço. 10 segundos.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit on chair. CLOSE and SQUEEZE 70%. Hold 10 seconds. Release 10 seconds.

If you cannot hold 10 seconds, hold as long as you can and note the time. Build from there.

Picture it: climbing stairs. Step 1 at 3 seconds. Step 2 at 5. Step 3 at 8. Step 4 at 10. Rest on each landing.`,
    inst_pt: `Sente na cadeira. FECHE e APERTE 70%. Segure 10 segundos. Solte 10 segundos.

Se não conseguir segurar 10 segundos, segure o quanto puder e anote. Construa a partir daí.

Visualize: subindo escadas. Degrau 1 em 3 segundos. Degrau 2 em 5. Degrau 3 em 8. Degrau 4 em 10. Descanse em cada patamar.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 10.
Release.`,
    timerCue_pt: `Aperte.
Segure 10.
Solte.`,
    feel: 'Strong sustained lift. A growing tiredness in the floor as the reps build.',
    feel_pt: 'Elevação sustentada forte. Cansaço crescente no assoalho conforme as repetições avançam.',
    avoid: 'Do not hold breath. Do not bear down.',
    avoid_pt: 'Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 8,
    hold: 10,
    relax: 10,
    rest: 0,
  },

  squeeze_8s: {
    id: 'squeeze_8s',
    name: 'Strong Hold 8s',
    name_pt: 'Sustentação Forte 8s',
    sub: '60% effort. 8 seconds. The last 2 seconds build strength.',
    sub_pt: '60% esforço. 8 segundos. Os últimos 2 segundos constroem força.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie down or sit. CLOSE and SQUEEZE at 60%. Hold 8 seconds. Breathe normally. The muscle should hold without fading. If it fades at 5 seconds, that is your edge. The edge is where growth happens.

Release completely for 8 seconds.

Picture it: holding a plank. Your body shakes at the limit. That shake is strength building.`,
    inst_pt: `Deite ou sente. FECHE e APERTE em 60%. Segure 8 segundos. Respire normal. O músculo deve se manter. Se enfraquecer em 5 segundos, esse é seu limite. O limite é onde o crescimento acontece.

Solte completamente por 8 segundos.

Visualize: segurando prancha. Corpo treme no limite. Tremor é força construindo.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 8.
Release.`,
    timerCue_pt: `Aperte.
Segure 8.
Solte.`,
    feel: 'Strong sustained lift. A trembling or harder pull near the end of the hold.',
    feel_pt: 'Elevação sustentada forte. Tremor ou puxada mais intensa perto do fim da sustentação.',
    avoid: 'Do not hold breath. Do not bear down. Do not compensate with glutes.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não compense com glúteos.',
    type: 'hold',
    sets: 10,
    hold: 8,
    relax: 8,
    rest: 0,
  },

  standing_squeeze: {
    id: 'standing_squeeze',
    name: 'Standing Squeeze',
    name_pt: 'Aperto em Pé',
    sub: 'Squeeze against gravity. Standing is harder.',
    sub_pt: 'Aperte contra a gravidade. Em pé é mais difícil.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. No wall support.

CLOSE and SQUEEZE at 60% for 5 seconds. Release for 5 seconds.

Standing squeezes are harder because gravity pulls on organs. If you cannot hold 5 seconds standing, reduce to 3.

Picture it: an invisible hand gently lifting your pelvic floor from below while you stand. The hand holds for 5 seconds, then lets go.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Sem apoio.

FECHE e APERTE em 60% por 5 segundos. Solte por 5 segundos.

Apertos em pé são mais difíceis porque gravidade puxa órgãos. Se não conseguir segurar 5 segundos, reduza para 3.

Visualize: uma mão invisível levantando suavemente seu assoalho de baixo enquanto está de pé. A mão segura 5 segundos, depois solta.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Hold.
Release.`,
    timerCue_pt: `Aperte.
Segure.
Solte.`,
    feel: 'Lift against gravity. The floor working with more effort to rise upward.',
    feel_pt: 'Elevação contra a gravidade. O assoalho trabalhando com mais esforço para subir.',
    avoid: 'Do not lock knees. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não trave joelhos. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  the_knack: {
    id: 'the_knack',
    name: 'The Knack',
    name_pt: 'O Knack',
    sub: 'Squeeze BEFORE the impact. Then release.',
    sub_pt: 'Aperte ANTES do impacto. Depois solte.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand upright.

Squeeze pelvic floor 1 second BEFORE each action. Hold through it. Release after.

Sequence 1: Squeeze, then cough. Release. 5 times.
Sequence 2: Squeeze, then bend to pick up object. Release. 5 times.
Sequence 3: Squeeze, then laugh out loud. Release. 5 times.
Sequence 4: Squeeze, then jump gently. Release. 5 times.

The squeeze ALWAYS comes before the impact.

Picture it: a goalkeeper bracing before a shot. They position BEFORE the ball arrives. Not during. Not after. Preparation before impact.`,
    inst_pt: `Fique de pé.

Aperte assoalho 1 segundo ANTES de cada ação. Mantenha durante. Solte depois.

Sequência 1: Aperte, depois tussa. Solte. 5 vezes.
Sequência 2: Aperte, depois abaixe para pegar objeto. Solte. 5 vezes.
Sequência 3: Aperte, depois ria alto. Solte. 5 vezes.
Sequência 4: Aperte, depois pule suavemente. Solte. 5 vezes.

O aperto SEMPRE vem antes do impacto.

Visualize: goleira se preparando antes do chute. Posiciona ANTES da bola chegar. Não durante. Não depois. Preparação antes do impacto.`,
    breathe: 'Squeeze before action. Release after.',
    breathe_pt: 'Aperte antes da ação. Solte depois.',
    timerCue: `Squeeze.
Action.
Release.`,
    timerCue_pt: `Aperte.
Ação.
Solte.`,
    feel: 'A small contraction landed before the impact, not after.',
    feel_pt: 'Uma pequena contração que chega antes do impacto, não depois.',
    avoid: 'Do not squeeze after the impact. The squeeze has to land first.',
    avoid_pt: 'Não aperte depois do impacto. O aperto tem que chegar antes.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },
};

export const days = [
  {
    day: 151, week: 22,
    title: 'Day 151', title_pt: 'Dia 151',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 152, week: 22,
    title: 'Day 152', title_pt: 'Dia 152',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 153, week: 22,
    title: 'Day 153', title_pt: 'Dia 153',
    exercises: [
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'standing_squeeze', overrides: {"sets": 11} }, // 110s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 154, week: 22,
    title: 'Day 154', title_pt: 'Dia 154',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'the_knack', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 155, week: 23,
    title: 'Day 155', title_pt: 'Dia 155',
    exercises: [
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 156, week: 23,
    title: 'Day 156', title_pt: 'Dia 156',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'belly_breath_drop', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 157, week: 23,
    title: 'Day 157', title_pt: 'Dia 157',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 158, week: 23,
    title: 'Day 158', title_pt: 'Dia 158',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'standing_squeeze', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 159, week: 23,
    title: 'Day 159', title_pt: 'Dia 159',
    exercises: [
      { ref: 'the_knack', overrides: {} }, // 150s
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 160, week: 23,
    title: 'Day 160', title_pt: 'Dia 160',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'pulsacao', overrides: {"sets": 4} }, // 126s
    ], // Total: 286s = 4.8 min
  },
  {
    day: 161, week: 23,
    title: 'Day 161', title_pt: 'Dia 161',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
    ], // Total: 292s = 4.9 min
  },
  {
    day: 162, week: 24,
    title: 'Day 162', title_pt: 'Dia 162',
    exercises: [
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 292.0s = 4.9 min
  },
  {
    day: 163, week: 24,
    title: 'Day 163', title_pt: 'Dia 163',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 164, week: 24,
    title: 'Day 164', title_pt: 'Dia 164',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
      { ref: 'fast_squeeze', overrides: {} }, // 174s
    ], // Total: 318s = 5.3 min
  },
  {
    day: 165, week: 24,
    title: 'Day 165', title_pt: 'Dia 165',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'bridge_activation', overrides: {} }, // 100s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 166, week: 24,
    title: 'Day 166', title_pt: 'Dia 166',
    exercises: [
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'bridge_activation', overrides: {} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 167, week: 24,
    title: 'Day 167', title_pt: 'Dia 167',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
    ], // Total: 292.0s = 4.9 min
  },
  {
    day: 168, week: 24,
    title: 'Day 168', title_pt: 'Dia 168',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 169, week: 25,
    title: 'Day 169', title_pt: 'Dia 169',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 170, week: 25,
    title: 'Day 170', title_pt: 'Dia 170',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
      { ref: 'squeeze_8s', overrides: {"sets": 11} }, // 176s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 171, week: 25,
    title: 'Day 171', title_pt: 'Dia 171',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 172, week: 25,
    title: 'Day 172', title_pt: 'Dia 172',
    exercises: [
      { ref: 'the_knack', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 292.0s = 4.9 min
  },
  {
    day: 173, week: 25,
    title: 'Day 173', title_pt: 'Dia 173',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 174, week: 25,
    title: 'Day 174', title_pt: 'Dia 174',
    exercises: [
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 292.0s = 4.9 min
  },
  {
    day: 175, week: 25,
    title: 'Day 175', title_pt: 'Dia 175',
    exercises: [
      { ref: 'fast_squeeze', overrides: {"sets": 3} }, // 128s
      { ref: 'squeeze_10s', overrides: {"sets": 9} }, // 180s
    ], // Total: 308s = 5.1 min
  },
  {
    day: 176, week: 26,
    title: 'Day 176', title_pt: 'Dia 176',
    exercises: [
      { ref: 'bridge_activation', overrides: {"sets": 15} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 177, week: 26,
    title: 'Day 177', title_pt: 'Dia 177',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 178, week: 26,
    title: 'Day 178', title_pt: 'Dia 178',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 179, week: 26,
    title: 'Day 179', title_pt: 'Dia 179',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'gentle_push_reset', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 180, week: 26,
    title: 'Day 180', title_pt: 'Dia 180',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'fast_squeeze', overrides: {"sets": 2} }, // 82s
      { ref: 'child_pose_release', overrides: {"hold": 118} }, // 118s
    ], // Total: 300s = 5.0 min
  },
];

export const milestone = {
  title: 'Month 6 Check-in',
  title_pt: 'Check-in do Mes 6',
  questions: [
    {
      q: 'Can you hold 10 seconds and do The Knack before coughing?',
      q_pt: 'Consegue segurar 10 segundos e fazer O Knack antes de tossir?',
      yes_response: 'You are on track. Continue to the next month.',
      yes_response_pt: 'Voce esta no caminho. Continue para o proximo mes.',
      no_response: 'Repeat this month for 2 more weeks. If no progress after 6 weeks total, consult a pelvic floor physiotherapist.',
      no_response_pt: 'Repita este mes por mais 2 semanas. Se sem progresso apos 6 semanas, consulte fisioterapeuta de assoalho pelvico.',
    },
  ],
};

export const monthMeta = {
  month: 6,
  program: 'release',
  phase: 'Foundation Peak',
  phase_pt: 'Pico da Base',
  days_range: [151, 180],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}